import StoryIcon from '@atlaskit/icon/core/story';
import * as React from 'react';

export function SvgWatchLater() {
  return <StoryIcon label="" testId="ads-refreshed-icon" />;
}
